import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { PersistGate } from "redux-persist/integration/react";
import "./assets/styles/app.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// eslint-disable-next-line
import lodashMixin from "./utils/lodashMixin"; // do not remove this
import store, { persistor } from "./store";
import { SocketProvider } from './components/common/SocketIo'

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF0990",
    },
  },
  typography: {
    fontFamily: '"Work Sans", sans-serif',
    h1: { fontSize: "var(--fs-h1)", fontWeight: 600 },
    h2: { fontSize: "var(--fs-h2)", fontWeight: 600 },
    h3: { fontSize: "var(--fs-h3)", fontWeight: 600 },
    h4: { fontSize: "var(--fs-h4)", fontWeight: 500 },
    h5: { fontSize: "var(--fs-h5)", fontWeight: 500, lineHeight: 1.3 },
    h6: { fontSize: "var(--fs-h6)", fontWeight: 600, lineHeight: 1.3 },
    subtitle1: { fontSize: "var(--fs-subtitle1)", fontWeight: 400 },
    subtitle2: { fontSize: "var(--fs-subtitle2)", fontWeight: 500 },
    body1: { fontSize: "var(--fs-body1)", fontWeight: 400 },
    body2: { fontSize: "var(--fs-body2)", fontWeight: 400 },
    caption: { fontSize: "var(--fs-caption)", fontWeight: 400 },
    overline: { fontSize: "var(--fs-small)", fontWeight: 500 },
    button: { fontSize: "14px", fontWeight: 500, lineHeight: 1 },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <SocketProvider>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </SocketProvider>
  </Provider >,
  document.getElementById("employHER")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
